import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.saju');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-saju',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.saju/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class LayoutSajuComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() { await this.service.init(); }
}

export default LayoutSajuComponent;